// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Q6w7v{overflow:hidden}.mexHr{overflow:hidden;position:relative}.mexHr.Mrl1i{border-radius:16px}.Pfymm{position:absolute;top:0;left:0;right:0;bottom:0;background-color:rgba(40,40,99,.08);pointer-events:none;z-index:1}.d43vT{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-direction:column;z-index:2}.z5f4w{top:32px;left:32px;right:32px;bottom:48px}.LDM7q{position:absolute;top:12px;right:12px;width:245px;z-index:3}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Q6w7v`,
	"contentBox": `mexHr`,
	"card": `Mrl1i`,
	"overlay": `Pfymm`,
	"contentArea": `d43vT`,
	"contentAreaCoverPage": `z5f4w`,
	"setupBrandContainer": `LDM7q`
};
export default ___CSS_LOADER_EXPORT___;
